import { getArrayDateFromStartDateToEndDate, getSomeDaysAgo } from '@/helpers/time';
import { IResponseApi } from '@/types/apis/response';

const start = getSomeDaysAgo(7);
const end = new Date();

const generateMockAnalyticsData = (startDate: Date, endDate: Date): IResponseApi.IAnalytic[] => {
  const dates = getArrayDateFromStartDateToEndDate(startDate, endDate);

  return dates.map((date, index) => {
    const totalVisitors = Math.floor(Math.random() * 500);

    const impressions = Math.floor(totalVisitors * 0.8);
    const hovers = Math.floor(impressions * 0.6);
    const clicks = Math.floor(hovers * 0.6);
    const addToCart = Math.floor(totalVisitors * 0.6);

    return {
      id: 31935 + (index % 5),
      shop: 'mock.test.com',
      ruleId: 31935 + (index % 5),
      createdAt: new Date(date).toISOString(),
      totalVisitorsProductPage: totalVisitors,
      totalBannerImpressions: impressions,
      totalHoverBannerETA: hovers,
      totalBannerClicks: clicks,
      totalAddToCart: addToCart,
    };
  }) as IResponseApi.IAnalytic[];
};

// Sử dụng:
export const mockDataAnalytics: IResponseApi.IAnalytic[] = generateMockAnalyticsData(start, end);

export const mockDataProductAnalytic: IResponseApi.IGetProductAnalytic = {
  code: 200,
  status: 'success',
  appliedProducts: [
    {
      ruleId: 31937,
      ruleName: 'Rule 1',
      totalProducts: 32,
    },
    {
      ruleId: 31938,
      ruleName: 'Rule 2',
      totalProducts: 15,
    },
    {
      ruleId: 31939,
      ruleName: 'Rule 3',
      totalProducts: 24,
    },
    {
      ruleId: 31936,
      ruleName: 'Rule 4',
      totalProducts: 5,
    },
    {
      ruleId: 31935,
      ruleName: 'Rule 5',
      totalProducts: 9,
    },
  ],
  totalActiveRules: 5,
  message: '',
};
